<template>
  <div :class="['mx-auto']" >
    <v-container>
      <v-row no-gutters class="align-start flex-column">
        <v-col cols="12" lg="6">
          <InfoCliente />
        </v-col>
      </v-row>
    </v-container>
    <v-card
      class="mx-auto mt-n5"
      elevation="2"
      outlined
      rounded="xl"
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-switch
        v-if="infoCliente(`GrupoCliente`, 1) !== 0"
        class="mt-1 mx-5"
        v-model="checkbox"
        color="accent"
        inset
        :loading="changeStatus"
        :disabled="changeStatus"
        flat
        :label="`Ver Consolidado`"
        @change="
          changeStatus = true;
          Consolidado();
        "
      ></v-switch>
      <v-card tile>
        <v-toolbar
          color="primary"
          dark
          dense
          class="elevation-0"
          style="height: 30px"
        >
          <v-toolbar-title class="mx-auto mb-4">Menú Cliente</v-toolbar-title>
        </v-toolbar>
        <LoadingChStatus :condition="changeStatus" />
        <v-list subheader>
          <v-subheader class="">Tareas</v-subheader>
          <div class="d-flex justify-space-between">
            <v-btn
              @click="handleMenu"
              color="success"
              text
              small
              class="mx-2 font-weight-bold"
            >
              <v-icon left size="30">mdi-cart-plus</v-icon>
              Cargar Pedido
            </v-btn>

            <v-btn
              v-if="Pedido.data.TotItem && Pedido.data.TotItem !== 0"
              color="primary"
              @click="toTopGo()"
              small
              class="mr-2 font-weight-bold"
              text
              to="/Carrito/"
              :disabled="!Pedido.data.TotItem"
            >
              <v-badge
                color="primary"
                :content="Pedido.data.TotItem !== 0 ? Pedido.data.TotItem : ''"
                ><v-icon left size="30">mdi-cart-variant</v-icon>
              </v-badge>
              <span class="mt-1">
                {{
                  Pedido.data.TotItem && Pedido.data.TotItem !== 0
                    ? TotalPedido
                    : 0
                }}
              </span>
            </v-btn>
          </div>

          <v-divider class="mt-1"></v-divider>
          <LoadingChStatus :condition="peticionCliente" />
          <v-list-group
            class="mt-1"
            v-for="item in itemsResumen.filter(
              (item) => item.id !== 9 || dataUser.TipoUsuario !== 'C'
            )"
            :key="item.title"
            v-model="item.active"
            active-class="primary"
            :prepend-icon="item.action"
            no-action
            @click="
              Object.entries(item.items).length ? false : procesaItem(item)
            "
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title
                  :class="{
                    'white--text': item.active,
                    'grey--text text--darken-4': !item.active,
                  }"
                  class="font-weight-bold text-uppercase"
                >
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </template>

            <v-list-item
              v-for="child in item.items.filter(
                (item) => item.id !== 1 || dataUser.TipoUsuario !== 'C'
              )"
              :key="child.title"
            >
              <v-list-item-content @click="procesaItem(child)">
                <v-list-item-title class="mx-3 font-weight-light">
                  {{ child.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-card>
    </v-card>
    <!-- vista pc -->
    <div v-if="!$vuetify.breakpoint.smAndDown">
      <v-container
        v-if="Object.entries(this.dsEstadistica).length === 0 && validaUser"
      >
        <v-card outlined>
          <v-card
            class="mx-auto pa-3"
            flat
            elevation="0"
            max-width="900"
            color="white"
          >
            <SkeletonLoading
              :class="`mx-auto`"
              :width="`900`"
              :type="`table`"
              :condition="true"
            />
          </v-card>
        </v-card>
      </v-container>
      <v-container v-else>
        <v-card outlined class="mt-n6">
          <v-row no-gutters>
            <v-col cols="12" sm="4">
              <v-switch
                v-if="Cliente.data.GrupoCliente !== 0"
                class="mx-3"
                v-model="checkbox"
                color="accent"
                inset
                :loading="changeStatus"
                :disabled="changeStatus"
                flat
                :label="`Ver Consolidado`"
                @change="
                  tab === 0 || tab === 1
                    ? (Consolidado(), (changeStatus = true))
                    : tab === 2
                    ? OpcionConsol(1)
                    : tab === 3
                    ? OpcionConsol(5)
                    : tab === 4
                    ? OpcionConsol(2)
                    : tab === 5
                    ? OpcionConsol(4)
                    : null
                "
              ></v-switch
            ></v-col>
          </v-row>

          <v-tabs
            show-arrows
            class="mt-n3"
            dark
            v-model="tab"
            background-color="primary"
            centered
            slider-color="red"
            @change="handleTabChange"
          >
            <v-tab @click="Opcion(1)" id="0">
              <span>Resumen</span>
            </v-tab>

            <v-tab
              @click="Opcion(2)"
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              <span>Documentos Pendientes</span>
            </v-tab>
            <v-tab
              @click="OpcionConsol(1)"
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              <span>Pedidos en Transito </span>
            </v-tab>
            <v-tab
              @click="OpcionConsol(5)"
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              Backorder
            </v-tab>
            <v-tab
              @click="OpcionConsol(2)"
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              Por Autorizar
            </v-tab>
            <v-tab
              @click="OpcionConsol(4)"
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              Presupuestos
            </v-tab>
            <v-tab
              
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              Datos
            </v-tab>
            <v-tab
              @click="
                OpcionConsol(8);
                SET_SHOULD_CONTINUE(true);
              "
              :disabled="DetalleCliente.length === 0"
              :id="tab"
            >
              Articulos
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless class="pa-2">
            <v-tab-item :transition="false" :reverse-transition="false">
              <v-row justify="start">
                <!-- Analisis de Vencimiento -->
                <v-col
                  cols="12"
                  sm="12"
                  lg="4"
                  xl="4"
                  md="6"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <CardResumen>
                    <LoadingChStatus :condition="changeStatus" />
                    <TitleCard :label="`Analisis de Vencimiento`" />

                    <SkeletonLoading
                      :class="`mx-auto`"
                      :width="`500`"
                      :type="`table-tbody`"
                      :condition="SaldoInfo(`SaldoPendiente`) === null"
                    />

                    <v-list
                      class="transparent"
                      dense
                      v-if="SaldoInfo(`SaldoPendiente`) !== null"
                    >
                      <ListResumen
                        :label="`Limite de Crédito`"
                        :value="`${
                          simboloMoneda[tipoMoneda]
                        } ${formatMilesCliente({
                          value: infoCliente(`LimiteCred`, 0)[0],
                          numDecimal: 0,
                        })}`"
                      />
                      <ListResumen
                        v-for="i in Saldos"
                        :key="i.key"
                        :label="`${i.title}`"
                        :styleclass="i.class"
                        :value="`${simboloMoneda[tipoMoneda]} 
                        ${formatMilesCliente({
                          value: SaldoInfo(i.monto),
                          numDecimal: 2,
                        })}`"
                      />

                      <v-subheader
                        class="subtitle-1 font-weight-bold mx-2 text--secondary"
                      >
                        Desglose de Vencimiento</v-subheader
                      >
                      <ListResumen
                        v-for="i in Vencido"
                        :key="i.key"
                        :label="`${i.title}`"
                        :styleclass="`text-right
                              red--text
                              text--darken-2
                              subtitle-1
                              font-weight-bold`"
                        :value="`${
                          simboloMoneda[tipoMoneda]
                        } ${formatMilesCliente({
                          value: SaldoInfo(i.monto),
                          numDecimal: 2,
                        })}`"
                      />
                    </v-list>
                  </CardResumen>
                </v-col>
                <!--Estadistica-->
                <v-col
                  cols="12"
                  sm="12"
                  lg="4"
                  xl="4"
                  md="6"
                  v-if="
                    $vuetify.breakpoint.mdAndUp && dataUser.TipoUsuario !== 'C'
                  "
                >
                  <CardResumen>
                    <LoadingChStatus :condition="changeStatus" />
                    <TitleCard :label="`Estadistica`" />

                    <SkeletonLoading
                      :class="`mx-auto`"
                      :width="`500`"
                      :type="`table-tbody`"
                      :condition="
                        SaldoInfo(`PagosAno`) === null &&
                        SaldoInfo(`PagosMes`) === null
                      "
                    />

                    <v-list
                      class="transparent"
                      dense
                      v-if="
                        SaldoInfo(`PagosAno`) !== null &&
                        SaldoInfo(`PagosMes`) !== null
                      "
                    >
                      <ListResumen
                        v-for="i in EstaClie"
                        :key="i.key"
                        :label="`${i.title} ${
                          i.tipo === `anio`
                            ? ` ${anioEstaClie}`
                            : ` Mes en curso`
                        }`"
                        :styleclass="i.class"
                        :value="`${simboloMoneda[tipoMoneda]} 
                        ${
                          i.tipo === `anio`
                            ? formatMilesCliente({
                                value: ItemClienteInfo(i.monto),
                                numDecimal: 2,
                              })
                            : formatMilesCliente({
                                value: SaldoInfo(i.monto),
                                numDecimal: 2,
                              })
                        }`"
                      />
                    </v-list>
                  </CardResumen>
                </v-col>
                <!-- Pedidos-->
                <v-col
                  cols="12"
                  sm="12"
                  lg="4"
                  xl="4"
                  md="6"
                  v-if="$vuetify.breakpoint.mdAndUp"
                >
                  <CardResumen>
                    <LoadingChStatus :condition="changeStatus" />
                    <TitleCard :label="`Pedidos`" />

                    <SkeletonLoading
                      :class="`mx-auto`"
                      :width="`500`"
                      :type="`table-tbody`"
                      :condition="
                        SaldoInfo(`MontoPedTransito`) === null &&
                        SaldoInfo(`MontoPedBackorder`) === null &&
                        SaldoInfo(`MontoPedAutorizar`) === null &&
                        SaldoInfo(`MontoPedPresupuesto`) === null &&
                        SaldoInfo(`MontoPedPenCobro`) === null
                      "
                    />
                    <v-list
                      class="transparent"
                      dense
                      v-if="
                        SaldoInfo(`MontoPedTransito`) !== null &&
                        SaldoInfo(`MontoPedBackorder`) !== null &&
                        SaldoInfo(`MontoPedAutorizar`) !== null &&
                        SaldoInfo(`MontoPedPresupuesto`) !== null &&
                        SaldoInfo(`MontoPedPenCobro`) !== null
                      "
                    >
                      <ListResumen
                        v-for="i in Pedidos.filter((pedido) => pedido.visible)"
                        :key="i.key"
                        :label="`${i.title}`"
                        :value="`${
                          simboloMoneda[tipoMoneda]
                        } ${formatMilesCliente({
                          value: SaldoInfo(i.monto),
                          numDecimal: 2,
                        })}`"
                        @list-click="opcionTab(i)"
                      />
                    </v-list>
                  </CardResumen>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  lg="10"
                  xl="8"
                  v-if="
                    dataUser.TipoUsuario !== 'C' && $vuetify.breakpoint.mdAndUp
                  "
                >
                  <CardResumen :width="`100%`">
                    <LoadingChStatus :condition="changeStatus" />
                    <TitleCard
                      v-if="$vuetify.breakpoint.mdAndUp"
                      :label="`Consulta Estadisticas de Cliente`"
                    />
                    <Estadisticas :verconsol="checkbox" />
                  </CardResumen>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Tabs Documentos Pendientes -->
            <v-tab-item :transition="false" :reverse-transition="false">
              <DocumentosPendiente
                :key="idComponent"
                :idcliente="infoCliente(`Codigo`, 1)"
                v-if="tab === 1"
              />
            </v-tab-item>
            <!-- Tabs Pedidos en Transito -->
            <v-tab-item :transition="false" :reverse-transition="false">
              <PedidosTransito
                :key="idComponent"
                :idcliente="infoCliente(`Codigo`, 1)"
                v-if="tab === 2"
              />
            </v-tab-item>
            <!-- Tabs Pedidosen BackOrder -->
            <v-tab-item :transition="false" :reverse-transition="false">
              <PedidosBackOrder
                :key="idComponent"
                :idcliente="infoCliente(`Codigo`, 1)"
                v-if="tab === 3"
              />
            </v-tab-item>
            <!-- Tabs Por Autorizar -->
            <v-tab-item :transition="false" :reverse-transition="false">
              <PedidosPendienteCobro
                :key="idComponent"
                :idcliente="infoCliente(`Codigo`, 1)"
                v-if="tab === 4"
              />
            </v-tab-item>
            <!-- Tabs Documentos en Presupuestos -->
            <v-tab-item :transition="false" :reverse-transition="false">
              <PedidosPresupuesto
                :key="idComponent"
                :idcliente="infoCliente(`Codigo`, 1)"
                v-if="tab === 5"
              />
            </v-tab-item>
            <v-tab-item :transition="false" :reverse-transition="false">
              <DatosCliente :key="idComponent" />
            </v-tab-item>
            <v-tab-item :transition="false" :reverse-transition="false">
              <detalleClienteArt
                :tipocliente="checkbox"
                :key="idComponent"
                v-if="
                  dataUser.TipoUsuario == 'U' && $vuetify.breakpoint.mdAndUp
                "
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-container>
    </div>
    <v-bottom-sheet
      v-model="sheet"
      persistent
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <v-sheet class="text-center" height="650px">
        <v-toolbar dense class="white--text elevation-0 primary">
          <v-toolbar-title class="mx-auto">
            {{ itemLista.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon @click="sheet = false" dark large>mdi-close</v-icon>
        </v-toolbar>

        <div class="py-3">
          <AnalisisVencimiento v-if="itemLista.id === 0" :key="IdAnalisisVen" />
          <Estadistica v-if="itemLista.id === 1" :key="IdEstadistica" />
          <Pedidos v-if="itemLista.id === 2" :key="IdPedido" />
          <DocumentosPendienteMobil
            v-if="itemLista.id === 3"
            :key="IdDocPend"
          />
          <PedidosTransitoMobil v-if="itemLista.id === 4" :key="IdTransito" />
          <PedidosBackOrderMobil
            v-if="itemLista.id === 5"
            :key="IdPedidosBack"
            :codcli="infoCliente(`Codigo`, 1)"
          />
          <PedidosPorAutorizarMobil v-if="itemLista.id === 6" :key="IdPorAut" />
          <PedidosPresupMobil v-if="itemLista.id === 7" :key="IdPresup" />
          <EstadisticaCli v-if="itemLista.id === 9" :key="IdEstadis" />
          <MenuCategorias v-if="itemLista.id === 10" :key="IdMenuCat" />
          <DatosCliente v-if="itemLista.id === 11" :key="IdDatos" />
        </div>
      </v-sheet>
    </v-bottom-sheet>
    <div class="mb-5"></div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import detalleClienteArt from "@/components/DetalleClienteArt";
import detalleClienteArtM from "@/components/DetalleClienteArtMobil";
import AnalisisVencimiento from "./ResumenCliente/ResumenAnalisisVencimiento";
import Estadistica from "./ResumenCliente/ResumenEstadistica";
import MenuCategorias from "./ResumenCliente/MenuCategoria";
import Pedidos from "./ResumenCliente/ResumenPedidos";
import EstadisticaCli from "./ResumenCliente/EstadisticasCliente";
import DatosCliente from "./DatosCliente";
import { formatMilesCliente } from "@/static/funciones";
import {
  PedidosTransito,
  PedidosBackOrder,
  PedidosPendienteCobro,
  PedidosPresupuesto,
  DocumentosPendiente,
  Estadisticas,
  DocumentosPendienteMobil,
  PedidosBackOrderMobil,
  PedidosTransitoMobil,
  PedidosPresupMobil,
  PedidosPorAutorizarMobil,
  InfoCliente,
  ListResumen,
  LoadingChStatus,
  SkeletonLoading,
  TitleCard,
  CardResumen,
} from "./DocumentosCliente";

export default {
  components: {
    InfoCliente,
    PedidosTransito,
    DocumentosPendienteMobil,
    PedidosBackOrderMobil,
    PedidosTransitoMobil,
    PedidosPresupMobil,
    PedidosPorAutorizarMobil,
    DocumentosPendiente,
    Estadisticas,
    PedidosPresupuesto,
    PedidosBackOrder,
    PedidosPendienteCobro,
    detalleClienteArt,
    detalleClienteArtM,
    AnalisisVencimiento,
    Estadistica,
    EstadisticaCli,
    Pedidos,
    //documentosPendientes,
    MenuCategorias,
    DatosCliente,
    ListResumen,
    LoadingChStatus,
    SkeletonLoading,
    TitleCard,
    CardResumen,
  },
  data() {
    return {
      idMenu: 0,
      IdPresup: 0,
      IdPorAut: 0,
      IdAnalisisVen: 0,
      IdEstadistica: 0,
      IdPedido: 0,
      IdTransito: 0,
      IdDocPend: 0,
      IdPedTrn: 0,
      IdEstadis: 0,
      IdPedidosBack: 0,
      IdMenuCat: 0,
      IdDatos: 0,
      sheet: false,
      itemLista: "",
      itemsResumen: [
        {
          id: 7,
          action: "mdi-format-list-bulleted",
          active: false,
          items: [
            { id: 0, title: "Analisis de Vencimiento" },
            { id: 1, title: "Estadistica" },
            { id: 2, title: "Pedidos" },
          ],
          title: "Resumen",
        },
        {
          id: 8,
          action: "mdi-file-document",
          active: false,
          items: [
            { id: 3, title: "Documentos Pendientes" },
            { id: 4, title: "Pedidos en Transito" },
            { id: 5, title: "Pedidos en BackOrder" },
            { id: 6, title: "Pedidos Por Autorizar" },
            { id: 7, title: "Pedidos en Presupuestos" },
          ],
          title: "Documentos y Pedidos",
        },
        /* {
          id: 8,
          action: "mdi-account-details",
          active: false,
          items: [],
          title: "Consulta Articulos Cliente",
        }, */
        {
          id: 9,
          action: "mdi-account-cash",
          active: false,
          items: [],
          title: "Consulta Estadisticas Cliente",
        },
        {
          id: 11,
          action: "mdi-account",
          active: false,
          items: [],
          title: "Datos Cliente",
        },
      ],
      search: "",
      selectRif: 0,
      isMobile: false,
      checkbox: true,
      changeStatus: false,
      resumenCli: [],
      tab: 0,
      initialLoad: true,
      tabs: null,
      datosCliente: [],
      output: null,
      Saldos: [
        {
          key: 0,
          title: "Saldo Pendiente",
          monto: "SaldoPendiente",
          class: "blue--text text--darken-4",
        },
        {
          key: 1,
          title: "No Vencido",
          monto: "SaldoNoVencido",
          class: "blue--text text--darken-4",
        },
        {
          key: 2,
          title: "Vencido",
          monto: "SaldoVencido",
          class: "red--text text--darken-2",
        },
      ],
      Vencido: [
        {
          key: 10,
          title: "Vencido 0-30 Días",
          monto: "SaldoVencido30",
        },
        {
          key: 11,
          title: "Vencido 31-60 Días",
          monto: "SaldoVencido60",
        },
        {
          key: 12,
          title: "Vencido > 60 Días",
          monto: "SaldoVencidoMas60",
        },
      ],
      EstaClie: [
        {
          key: 20,
          title: "Compras",
          monto: "TCompras",
          tipo: "anio",
          tcol: 6,
          mcol: 6,
        },
        {
          key: 21,
          title: "Pagos",
          monto: "TPagos",
          tipo: "anio",
          tcol: 6,
          mcol: 6,
        },
        {
          key: 22,
          title: "Compras",
          monto: "ComprasMes",
          tipo: "mes",
          tcol: 7,
          mcol: 5,
        },
        {
          key: 23,
          title: "Pagos",
          monto: "PagosMes",
          tipo: "mes",
          tcol: 7,
          mcol: 5,
        },
      ],
      Pedidos: [
        {
          key: 30,
          title: "En Transito",
          monto: "MontoPedTransito",
          tab: 2,
          visible: true,
          hover: true,
        },
        {
          key: 31,
          title: "En Backorder",
          monto: "MontoPedBackorder",
          tab: 3,
          visible: true,
          hover: true,
        },
        {
          key: 32,
          title: "Por Autorizar",
          monto: "MontoPedAutorizar",
          tab: 4,
          visible: true,
          hover: true,
        },
        {
          key: 33,
          title: "Presupuestos",
          monto: "MontoPedPresupuesto",
          tab: 5,
          visible: true,
          hover: true,
        },
        {
          key: 34,
          title: "Pendientes de Cobro",
          monto: "MontoPedPenCobro",
          tab: 0,
          visible: true,
          hover: false,
        },
      ],
    };
  },
  filters: {
    nocero: function (value) {
      return parseInt(value) != 0 ? value : "";
    },
  },
  mounted() {
    this.initialLoad = true; // Activar la bandera en la carga inicial
  },
  watch: {
    validaUser() {
      this.validaUser;
    },
    activeTab() {
      this.handleTabChange();
    },
  },
  methods: {
    ...mapActions(["get_DetalleCliente", "get_dsEstadistica"]),
    ...mapMutations("mod_cliente", ["clr_wfVentasAno", "SET_SHOULD_CONTINUE"]),
    ...mapActions("mod_cliente", ["GetDatosCliente", "cancelarPeticiones"]),
    formatMilesCliente,
    handleTabChange() {
      if (!this.initialLoad) {
        this.cancelarPeticiones();
      }
      this.initialLoad = false;
    },
    opcionTab(i) {
      console.log(i);
      this.tab = i.tab;
      i.tab === 1
        ? this.Opcion(2)
        : i.tab === 2
        ? this.OpcionConsol(1)
        : i.tab === 3
        ? this.OpcionConsol(5)
        : i.tab === 4
        ? this.OpcionConsol(2)
        : i.tab === 5
        ? this.OpcionConsol(4)
        : null;
    },
    toTopGo() {
      window.scrollTo(0, 0);
      this.set_AdPromoF();
    },

    ...mapMutations([
      "set_GrupoCli",
      "setTabMovil",
      "set_idComponente",
      "clr_dsEstadistica",
      "set_disableNav",
      "set_OpcCli",
      "CLR_DATOS_ART",
      "CRL_DetalleCliente",
      "set_AdPromoF",
      "CRL_DetalleClientePre",
      "CRL_DetalleClienteDif",
      "CLR_FACTDOC_PENDIENTES",
      "CLR_ITEMSFACTDOC_PENDIENTES",
      "set_changeCliente",
      "CLR_ERROR_AXIOS",
    ]),
    handleMenu() {
      this.$router.push({ path: `/carrito/` }).catch((err) => {});
    },
    procesaItem(item) {
      this.idMenu++;

      const idKey = {
        0: () => this.IdAnalisisVen++,
        1: () => this.IdEstadistica++,
        2: () => this.IdPedido++,
        3: () => this.IdDocPend++,
        4: () => this.IdTransito++,
        5: () => this.IdPedidosBack++,
        6: () => this.IdPorAut++,
        7: () => this.IdPresup++,
        9: () => this.IdEstadis++,
        10: () => this.IdMenuCat++,
        11: () => this.IdDatos++,
      };
      idKey[item.id]();
      this.setTabMovil(item.id);
      this.sheet = true;
      this.itemLista = item;
    },

    async estadisticas() {
      // await this.set_GrupoCli(0);
      //this.clr_dsEstadistica();

      await this.get_dsEstadistica({
        opc: 4,
        anio: this.anioEstaClie,
        vergrupo:
          this.Cliente.data.GrupoCliente == 1 ? (this.checkbox ? 1 : 0) : 0,
      });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    print() {
      // Pass the element id here
      this.$htmlToPaper("printMe");
    },
    async Opcion(op) {
      if (op === 1) {
        await this.estadisticas();
      }

      this.CLR_ITEMSFACTDOC_PENDIENTES();
      this.CLR_FACTDOC_PENDIENTES();
      this.set_OpcCli(op);
      await this.get_DetalleCliente();
      //verificar comportamiento 14/6/2022 angel
    },
    async OpcionConsol(op) {
      //  if (this.Cliente.data.GrupoCliente != 0) {

      if (this.checkbox === true) {
        this.set_GrupoCli(1);
        this.set_OpcCli(op);
        this.set_idComponente();
        this.changeStatus = false;
      } else {
        this.set_GrupoCli(0);
        this.set_OpcCli(op);
        this.set_idComponente();
        this.changeStatus = false;
      }
      // }
    },

 

    async Consolidado() {
      if (this.checkbox === true) {
        this.set_GrupoCli(1);
        await this.get_DetalleCliente();
        await this.estadisticas();

        this.changeStatus = false;
      } else {
        this.set_GrupoCli(0);
        await this.get_DetalleCliente();
        await this.estadisticas();

        this.changeStatus = false;
      }
    },
  },

  beforeUpdate() {
    if (this.changeCliente === true) {
      this.set_changeCliente();

      //llamo funcion que carga resumen en tab 0
      this.Opcion(1);
      //defaul tab 0
      this.tab = 0;

      this.CRL_DetalleClienteDif();
      this.CRL_DetalleClientePre();
    }
  },
  created() {
    this.tab = 0;
    //this.CRL_DetalleCliente();
    //this.CLR_FACTDOC_PENDIENTES()
    this.Opcion(1);
  },

  computed: {
    ...mapState("mod_cliente", ["wfVentasAno", "peticionCliente"]),
    ...mapState([
      "dirPHP",
      "Cliente",
      "idComponent",
      "simboloMoneda",
      "tipoMoneda",
      "dsEstadistica",
      "anioEstaClie",
      "dataUser",
      "GrupoCli",
      "DetalleCliente",
      "Pedido",
      "DetalleClientePre",
      "DetalleClienteDif",
      "factDocPendientes",
      "factDocItemsFactura",
      "peticionDocCliente",
      "changeCliente",
    ]),
    TotalPedido() {
      let numeral = require("numeral");
      let monto = numeral(this.Pedido.data.MontoTotal[this.tipoMoneda]).format(
        "0,0.00"
      );
      return this.simboloMoneda[this.tipoMoneda] + " " + monto;
    },
    ncli() {
      let nc = 0;
      if (Object.entries(this.wfVentasAno).length !== 0) {
        let { wfVentasAno: wfVentasAno } = this.wfVentasAno.datos;
        nc = wfVentasAno.length;
      }
      return nc;
    },
    validaUser() {
      if (this.dataUser.IndAutenticado && !this.Cliente.showOpc) return true;
      else {
        this.$router.push({ path: `/` }).catch((err) => {});
        return false;
      }
    },

    SaldoInfo: function () {
      return function (idKey) {
        let datos = null;
        if (Object.entries(this.DetalleCliente).length !== 0) {
          let { ttResumen: ttResumen } = this.DetalleCliente;
          if (ttResumen !== undefined) {
            datos = ttResumen[0][idKey][this.tipoMoneda];
          }
        }
        return datos;
      };
    },

    //infoCliente(`Codigo`, 1)
    infoCliente: function () {
      return function (idKey, idNodo) {
        let xInfo = [];
        const infoData = {
            0: `resumen`,
            1: `data`,
          },
          attrib = infoData[idNodo];

        if (Object.entries(this.Cliente[attrib]).length !== 0) {
          const { [idKey]: Codigo } = this.Cliente[attrib];
          const { [idKey]: Nombre } = this.Cliente[attrib];
          const { [idKey]: Descuento } = this.Cliente[attrib];
          const { [idKey]: CodigoVen } = this.Cliente[attrib];
          const { [idKey]: NombreVen } = this.Cliente[attrib];
          const { [idKey]: GrupoCliente } = this.Cliente[attrib];

          if (Codigo !== undefined) xInfo = Codigo;
          if (Nombre !== undefined) xInfo = Nombre;
          if (Descuento !== undefined) xInfo = Descuento;
          if (CodigoVen !== undefined) xInfo = CodigoVen;
          if (NombreVen !== undefined) xInfo = NombreVen;
          if (GrupoCliente !== undefined) xInfo = GrupoCliente;
        }
        return xInfo;
      };
    },
    ItemClienteInfo() {
      return (idKey) => {
        let xMonto = [];
        if (Object.entries(this.dsEstadistica).length !== 0) {
          let { ttestinfo: ttestinfo } = this.dsEstadistica.dsEstadistica;

          if (Object.entries(ttestinfo).length !== 0) {
            xMonto = ttestinfo[0][idKey][this.tipoMoneda];
          }
        }
        return xMonto;
      };
    },
  },
};
</script>

<style scoped>
.v-cardgrid {
  background-color: #ffffff !important;
  border: 1px solid #fe5000 !important;
  transition: opacity 0.4s ease-in-out;
  margin: 1px;
}
.tbl_datos tr:nth-child(odd) {
  background: #ffffff;
  font-size: 11px;
  padding: 1px;
}
.tbl_datos tr:nth-child(even) {
  font-size: 11px;
  background: #e0e0e0;
  padding: 1px;
}

.mobile {
  color: #333;
}

@media screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr:nth-child(odd) {
    border-left: 6px solid deeppink;
  }

  .mobile table.v-table tr:nth-child(even) {
    border-left: 6px solid cyan;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    display: block;
    color: #999;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 5px;
  height: 40px;
  font-weight: bold;
}
.flex-txt {
  padding: 6px;
  width: 50%;
  height: 45px;
}
</style>
